import * as actionTypes from "../actionType/action-type";

const initialState = {
  isAuthenticated: false,
  user: JSON.parse(localStorage.getItem("user")),
  isSwitchUser: false,
  isModalShown: localStorage.getItem("isModalShown") === "true" || false,
};

const Auth = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actionTypes.AUTH_LOGIN:
      return authLogin(state, payload);
    case actionTypes.AUTH_CHECK:
      return checkAuth(state);
    case actionTypes.AUTH_LOGOUT:
      return logout(state);
    case actionTypes.AUTH_SWITCHUSER:
      return switchUserLogout(state);
    case actionTypes.AUTH_SWITCHUSER_FALSE:
      return switchUserFalse(state);
       case actionTypes.SET_MODAL_SHOWN:
      return setModalShown(state);
    default:
      return state;
  }
};

const authLogin = (state, payload) => {
  localStorage.setItem("user", JSON.stringify(payload));
  localStorage.setItem("isModalShown", "false"); 
  let newState = {
    isAuthenticated: true,
    user: payload,
    isModalShown: false,
  };
  state = Object.assign({}, state, newState);
  return state;
};
const logout = (state) => {
  localStorage.removeItem("user");
  localStorage.setItem("isModalShown", "false");
  //sessionStorage.removeItem("user");
  state = Object.assign({}, state, {
    isAuthenticated: false,
    user: null,
    isSwitchUser: false,
  });

  console.log("Removers");
  return state;
};
const switchUserLogout = (state) => {
  state = Object.assign({}, state, { isSwitchUser: true });
  return state;
};
const switchUserFalse = (state) => {
  state = Object.assign({}, state, { isSwitchUser: false });
  return state;
};

const checkAuth = (state) => {
  const _user = JSON.parse(localStorage.getItem("user"));
  if (_user && _user !== "") {
    state = Object.assign({}, state, {
      isAuthenticated: true,
      user: _user,
    });
  } else {
    state = Object.assign({}, state, {
      isAuthenticated: !!state.isAuthenticated,
    });
  }
  return state;
};
const setModalShown = (state) => {
  return { ...state, isModalShown: true };
};

export default Auth;
